import React from "react";
import { useI18n } from "../i18n";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
        {subtitle && <p className="text-slate-500 mt-1 text-sm">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

const tones = {
  teal: "bg-teal-50 text-teal-700", red: "bg-red-50 text-red-600", amber: "bg-amber-50 text-amber-600",
  blue: "bg-blue-50 text-blue-600", violet: "bg-violet-50 text-violet-600", emerald: "bg-emerald-50 text-emerald-600",
};

export function StatCard({ icon: Icon, label, value, sub, tone = "teal" }) {
  return (
    <div className="card-surface p-5 hover:shadow-md transition-shadow animate-fade-in">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-slate-500 font-medium">{label}</p>
          <p className="text-3xl font-bold text-slate-900 mt-2">{value}</p>
          {sub && <p className="text-xs text-slate-400 mt-1">{sub}</p>}
        </div>
        {Icon && <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${tones[tone]}`}><Icon className="w-5 h-5" /></div>}
      </div>
    </div>
  );
}

export function Card({ children, className = "" }) {
  return <div className={`card-surface ${className}`}>{children}</div>;
}

export function EmptyState({ icon: Icon, title }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="w-14 h-14 rounded-full bg-slate-100 flex items-center justify-center mb-4">
        {Icon && <Icon className="w-6 h-6 text-slate-400" />}
      </div>
      <p className="font-semibold text-slate-700">{title}</p>
    </div>
  );
}

export function ProgressBar({ value }) {
  const v = Math.max(0, Math.min(100, value || 0));
  const color = v >= 75 ? "#0f766e" : v >= 40 ? "#d97706" : "#dc2626";
  return (
    <div className="flex items-center gap-2 min-w-[90px]">
      <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden">
        <div className="h-full rounded-full" style={{ width: `${v}%`, backgroundColor: color }} />
      </div>
      <span className="text-xs text-slate-500 w-8 text-end">{v}%</span>
    </div>
  );
}
